import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight, MessageSquare, Mail, HelpCircle, AlertTriangle } from "lucide-react";

export default function Support() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith('en') ? 'en' : 'fr';

  const options = [
    { icon: MessageSquare, title: t("pages.supportChat"), desc: t("pages.supportChatDesc"), cta: t("pages.supportChatCta"), href: "#chat", color: "#FFC928" },
    { icon: Mail, title: t("pages.supportEmail"), desc: t("pages.supportEmailDesc"), cta: t("pages.supportEmailCta"), href: "/contact", color: "#3B82F6" },
    { icon: HelpCircle, title: t("pages.supportFaq"), desc: t("pages.supportFaqDesc"), cta: t("pages.supportFaqCta"), href: "/faq", color: "#22C55E" },
    { icon: AlertTriangle, title: t("pages.supportReport"), desc: t("pages.supportReportDesc"), cta: t("pages.supportReportCta"), href: "/report", color: "#EF4444" },
  ];

  return (
    <div className="min-h-screen bg-[#050814]" data-testid="support-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
        <nav className="flex items-center gap-2 text-sm text-[#94A3B8] mb-8">
          <Link to="/" className="hover:text-white transition-colors">{lang === 'fr' ? 'Accueil' : 'Home'}</Link>
          <ChevronRight size={14} />
          <span className="text-[#FFC928]">{t("pages.supportTitle")}</span>
        </nav>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-3xl sm:text-4xl font-bold text-white mb-3"
          style={{ fontFamily: 'Poppins' }}
          data-testid="support-title"
        >
          {t("pages.supportTitle")}
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="text-[#94A3B8] text-sm mb-10"
        >
          {t("pages.supportIntro")}
        </motion.p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {options.map((opt, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.15 + i * 0.08 }}
            >
              <Link
                to={opt.href}
                className="block rounded-2xl border border-white/[0.06] bg-[#0F172A] p-6 hover:border-[#FFC928]/20 transition-all group"
                data-testid={`support-option-${i}`}
              >
                <opt.icon size={28} style={{ color: opt.color }} className="mb-3" />
                <h3 className="text-white font-semibold text-base mb-2 group-hover:text-[#FFC928] transition-colors">{opt.title}</h3>
                <p className="text-[#94A3B8] text-sm mb-4 leading-relaxed">{opt.desc}</p>
                <span className="text-xs font-medium" style={{ color: opt.color }}>{opt.cta} →</span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
